import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { SearchService } from '../../search/services/search.service';
/**
 * Component for managing a user's saved searches.
 */
@Component({
	selector: 'my-searches',
	templateUrl: './my-searches.component.html',
	styleUrl: './my-searches.component.css'
})
export class MySearchesComponent implements OnInit, OnDestroy {
	
	private userEventSubscription!: Subscription;
	
	Object = Object;

	LOCALIZATION: any;

	expandedStates: boolean[] = [];

	// TODO create an interface for this data model
	mysearches: {
		name: string;
		created: string;
		createdDate: string;
		dataObj: {
			query: string;
			type: string;
			aoi: string;
			criteria: Record<string, { display_header: string; display_value: string }>;
			libraries: Record<string, any> | any[];
		};
	}[] = [
			{
				name: '',
				created: '',
				createdDate: '',
				dataObj: {
					query: '',
					type: '16',
					aoi: '',
					criteria: {},
					libraries: {}
				}
			}
		];

	constraints: any = {};
	pagination = {
		page: 1,
		elementsPerPage: 5,
		sorting: {
			sort: 'created,desc',
		},
		totalElements: 0,
		pageChanged: (newPage: any) => {
			this.pagination.page = newPage;
			this.loadSavedSearches(this.pagination.page);
		}
	};
	inprogress: boolean = false;

	constructor(
		private userService: UserService,
		private searchService: SearchService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	ngOnInit(): void {
		this.loadSavedSearches();
		
		this.userEventSubscription = this.userService.broadcastEvent.subscribe((event: string) => {
			if ('localizationLoaded' === event) {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			}
		});
	}
	
	ngOnDestroy() {
		if (this.userEventSubscription) {
			this.userEventSubscription.unsubscribe();
		}
	}

	/**
	 * Loads the user's saved searches using the current constraints.
	 */
	loadSavedSearches(page?: number): void {
		this.inprogress = true;

		if (page) {
			this.pagination.page = page;
		}

		let index = this.pagination.page - 1;

		this.searchService.getMySavedSearches(index, this.pagination, this.constraints).then(
			(data: any) => {
				if (!data) {
					this.mysearches = [];
				} else {
					this.mysearches = data.content;
					this.pagination.page = data.page.number + 1;
					this.pagination.elementsPerPage = data.page.size;
					this.pagination.totalElements = data.page.totalElements;
				}
				this.inprogress = false;
			},
			(err: any) => {
				console.error("Failed to fetch user's saved searches", err);
				this.mysearches = [];
				this.inprogress = false;
			}
		);
	}

	/**
	 * Executes a saved search.
	 */
	executeSearch(searchObj: any): void {
		let data = {
			searchObj: searchObj,
			notify: false
		};

		//			    if ($scope.mapDetached) {
		//			        data['broadcastSync'] = true;
		//			    }

		this.searchService.broadcastSearchEvent(data);
	}

	toggleExpand(index: number) {
		this.expandedStates[index] = !this.expandedStates[index];
	}
}
